var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"50px","text-align":"center"}},[_c('h1',[_vm._v("权限无法访问...")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }